import styled from '@emotion/styled';
import {
  device,
  Reveal,
  mobileGutterMargin,
  shouldForwardProp,
} from '@landsbankinn/ui';
import React, { useEffect } from 'react';

interface IProps {
  url?: string;
  background?: string;
  isSmaller?: boolean;
}

const Wrapper = styled(Reveal, {
  shouldForwardProp: shouldForwardProp('div'),
})<{ isSmaller?: boolean; background?: string }>`
  padding: 50px 30px;
  margin: ${(props) => (props.isSmaller ? '0 -34px 20px' : '0 -20px')};
  background-color: ${(props) =>
    props.background === 'Grey'
      ? props.theme.colors.backgroundAlt
      : 'transparent'};

  ${mobileGutterMargin}

  @media ${device.tablet} {
    margin: 0;
    margin-bottom: 20px;
    padding: ${(props) => (props.isSmaller ? '30px 20px' : '50px 65px')};
  }

  @media ${device.desktop} {
    margin-bottom: 0;
    padding: ${(props) => (props.isSmaller ? '40px 30px' : '60px 100px')};
  }
`;

const Host = styled.div``;

export function Infogram({ url, isSmaller, background, ...rest }: IProps) {
  useEffect(() => {
    const script = document.createElement('script');

    script.innerHTML = `!(function (e, i, n, s) {
      const t = 'InfogramEmbeds',
      d = e.getElementsByTagName('script')[0];
      if (window[t] && window[t].initialized)
        window[t].process && window[t].process();
      else if (!e.getElementById(n)) {
        const o = e.createElement('script');
        (o.async = 1),
          (o.id = n),
          (o.src = 'https://e.infogram.com/js/dist/embed-loader-min.js'),
          d.parentNode.insertBefore(o, d);
      }
    })(document, 0, 'infogram-async')`;

    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url]);

  return (
    <Wrapper isSmaller={isSmaller} background={background}>
      <Host
        className="infogram-embed"
        data-id={url}
        data-type="interactive"
        data-title="Untitled dashboard"
        {...rest}
      />
    </Wrapper>
  );
}
